export const resolveAllowFreeGiftSelection = (
  couponCodes = [],
  skipCodes = [],
) => {
  const appliedCodes = (couponCodes ?? []).map(code => code.toLowerCase());
  const hasSkipCode = (skipCodes ?? []).some(code =>
    appliedCodes.includes(code.toLowerCase()),
  );

  return !hasSkipCode;
};

export const getABTestFlags = flags =>
  Object.entries(flags)
    .map(([key, value]) => `${key}:${value}`)
    .join(',');
